import React from 'react';
import classNames from 'classnames';
import cls from './InDraftEstimates.module.css';
import { useInDraftEstimates } from './useInDraftEstimates';
import { DraftbarLine } from '../../UI/DraftbarLine/DraftbarLine';
import { ProgressbarLineList } from '../../UI/ProgressbarLineList/ProgressbarLineList';
import { DashboardEstimate } from '../../../../types/dashboardInformation';
import { HintEmptyEstimate } from '../../UI/HintEmptyEstimate/HintEmptyEstimate';
import { declension } from '../../helpers/declension';

interface InDraftEstimatesProps {
    classes?: string;
    activeTab: string;
}

export const InDraftEstimates = ({ classes, activeTab }: InDraftEstimatesProps) => {
    const { estimates, inDraftEstimates, is_customer } = useInDraftEstimates();
    return (
        <div className={classNames(cls.InDraftEstimates, [classes])}>
            {estimates.in_draft_estimates_count > 0 ? (
                <>
                    <div className={cls.Container}>
                        <div className={cls.DraftText}>
                            <span>
                                {estimates.in_draft_estimates_count}{' '}
                                {declension(estimates.in_draft_estimates_count, [
                                    i18next.t(
                                        'ProgressbarCircle.return.progressBarText.span.declension_estimate'
                                    ),
                                    i18next.t(
                                        'ProgressbarCircle.return.progressBarText.span.declension_estimates'
                                    ),
                                    i18next.t(
                                        'ProgressbarCircle.return.progressBarText.span.declension_estimates_without_s'
                                    ),
                                ])}{' '}
                                {i18next.t('InDraftEstimates.return.DraftText.span')}
                            </span>
                            <span>
                                {numberFormatter.formatMoney(estimates.in_draft_estimates_cost, 2, estimates.currency.sign)}
                            </span>
                        </div>
                    </div>
                    <div className={cls.ProgressbarLineListContainer}>
                        <ProgressbarLineList>
                            {inDraftEstimates.map((inDraftEstimate: DashboardEstimate, index: number) => (
                                <div key={inDraftEstimate.id} {...(index === 0 ? { 'data-hint-target': 'first-draft-estimate' } : {})}>
                                    <DraftbarLine
                                        estimateId={inDraftEstimate.id}
                                        estimateName={inDraftEstimate.name}
                                        estimateDate={inDraftEstimate.created_at}
                                        estimateStatus={inDraftEstimate.status}
                                    />
                                </div>
                            ))}
                        </ProgressbarLineList>
                    </div>
                </>
            ) : (
                <HintEmptyEstimate status={activeTab} isCustomer={is_customer} />
            )}
        </div>
    );
};
